import React, { useRef, useEffect } from "react";
import "./OurStory.style.css";
import WebData from "../../Helpers/WebData";
import ReactMarkdown from "react-markdown";

function OurStory() {
  const contentRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {}, []);
  const paragraph =
    "Samskrithi Goshala was born in 2010 in Punnayurkulam, Kerala, India. Our mission is simple - conserve indigenous breeds and make compassion and human health a central focus. Our family has 28 male and 57 female from six indigenous breeds - Sahiwal of Punjab, Gir of Gujarat and, Vilvaadri, Vechoor, Kazarkode dwarf and Vadakara of Kerala. These are sturdy and do not require antibiotics or special feeds. Their milk, dung and urine have high medicinal value. Nestled in the greenery, in the shadow of coconut trees, with beaches of the Sindhusagar to our west and 13 km north of the elephant camp of the Guruvayur Devaswom, Samskrithi Goshala lives on. Come visit us or spend some quality time on our digital home!";
  return (
    <section id="about" className="my-4 top-nav-space">
      <div className="global-heading text-center">Our Story</div>
      <div className="w-100 story-wrapper">
        <div className="story h-100 mx-auto rounded-3 d-flex">
          <div className="story-img ps-md-4 py-md-4">
            <img
              className="h-100 img-desktop"
              src={WebData.about.ourStory.images[0].imageUrl}
              alt=""
            />
            <img
              className="h-auto img-mob"
              src={WebData.about.ourStory.images[1].imageUrl}
              alt=""
            />
          </div>
          <div className="story-text py-4">
            <div
              ref={contentRef}
              className="scrollbar-hide h-100 w-100 d-flex align-items-center"
            >
              <div ref={textRef} className="custom-scrollbar">
                <ReactMarkdown>{paragraph}</ReactMarkdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurStory;
